import { Api } from "../../../uikit/service/api";

export const api = new Api(false);
